import { jsx as _jsx } from "react/jsx-runtime";
import TextButton from './TextButton';
import './TabButtons.css';
const TabButtons = ({ icons = [], labels = [], shortLabels = [], onClick, className, focusId, selectedIndex }) => {
    return (_jsx("div", { className: `tabButtonsContainer ${className !== null && className !== void 0 ? className : ''}`, children: labels.map((label, index) => {
            var _a;
            return (_jsx(TextButton, { className: selectedIndex === index ? 'selected' : '', icon: icons[index], label: label !== null && label !== void 0 ? label : shortLabels[index], shortLabel: (_a = shortLabels[index]) !== null && _a !== void 0 ? _a : label, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(index), sidewaysBehaviour: 'both', focussable: !index ? 'flow' : 'sideway', focusId: index ? undefined : focusId, type: 'borderless' }, index));
        }) }));
};
export default TabButtons;
